// Added to part of the bundle to reduce network requests
export default Object.freeze([
  'B00',
  'B01',
  'B02',
  'B03',
  'B04',
  'B05',
  'B06',
  'B07',
  'B08',
  'B09',
  'B10',
  'B11',
  'B12',
  'B13',
  'B14',
  'B15',
  'B16',
  'B17',
  'B18',
  'B19',
  'B20',
  'B21',
  'B22',
  'FOC',
  'FOD',
  'GAR',
  'GO0',
  'GO1',
  'GO2',
  'H45',
  'H46',
  'H47',
  'H48',
  'H49',
  'H50',
  'H51',
  'H52',
  'HD5',
  'HD6',
  'HD7',
  'LA1',
  'LA2',
  'LAN',
  'S07',
  'S08',
  'S09',
  'S10',
  'S11',
  'S12',
  'SMA',
]);
